import { Typography } from '@mui/material';

const Dashboard = () => <Typography> Dashboard</Typography>;

export default Dashboard;
